import React from 'react'
export const Song = () => {
    return (
        <div>
            <p>Work in progress....</p>
        </div>
    )
}